export default __webpack_public_path__ + "static/media/thumb-Marine-Receiver-1.e2d28da8.png";